module.exports = __webpack_public_path__ + "img/ck-mutil-star4-bg-side.9d8b5715.png";